import React from 'react';
import { Dialog as MuiDialog, DialogProps as MuiDialogProps, useMediaQuery, useTheme } from '@mui/material';

type DialogProps = MuiDialogProps & {
  children?: any;
};

export const Dialog = ({ children = null, ...rest }: DialogProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <MuiDialog
      fullScreen={down_sm}
      fullWidth
      maxWidth="sm"
      scroll="body"
      PaperProps={{
        sx: {
          borderTopWidth: 4,
          borderTopColor: theme.palette.primary.light,
          borderTopStyle: 'solid',
        },
      }}
      {...rest}
    >
      {children}
    </MuiDialog>
  );
};
